import { Component } from '@angular/core';

@Component({
  selector: 't-command-center-icon',
  standalone: true,
  imports: [],
  templateUrl: './command-center-icon.component.html',
  styleUrl: './command-center-icon.component.css',
})
export class CommandCenterIconComponent {}
